<template>
    <header-layout :user="user">
        <template #left_section>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'company'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                    <vue-feather class="mr-50" type="home" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Dashboard') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'team-index'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                    <vue-feather class="mr-50" type="users" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Teams') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'opportunities.pipeline'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                <vue-feather class="mr-50" type="target" size="15"></vue-feather>
                <span>{{ localizationStore.translate('opportunities.pipeline') }}</span>
                </router-link>
            </li>
            <li class="nav-item d-none d-md-block">
                <router-link
                    :to="{ name: 'products'}"
                    class="nav-link d-flex align-items-center px-2" target="_self"
                >
                    <vue-feather class="mr-50" type="book" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('ebook') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'chat-index'}"
                    class="nav-link d-flex align-items-center px-2"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="message-square" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('chat.navbar.title') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'messages'}"
                    aria-current="page" class="nav-link d-flex align-items-center px-2" target="_self" style="position: relative;"
                >
                    <div class="new-message" v-if="messageStore.newMessages"></div>
                    <vue-feather class="mr-50" type="message-circle" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('messages') }}</span>
                </router-link>
            </li>
            <li class="dropdown nav-item sidebar-group-active open">
                <a href="#" target="_self"
                    class="dropdown-toggle d-flex align-items-center" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                    >
                    <vue-feather class="mr-20" type="book-open" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('education') }}</span></a>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'academy'}"
                            class="nav-link d-flex align-items-center justify-content-start text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="monitor" size="15"></vue-feather>
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'courses'}"
                            class="nav-link d-flex align-items-center justify-content-start text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="monitor" size="15"></vue-feather>
                            <span>{{ localizationStore.translate('education.courses') }}</span>
                        </router-link>
                    </li>
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'user-courses'}"
                            class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="archive" size="15"></vue-feather>
                            <span>{{ localizationStore.translate('education.user.courses') }}</span>
                        </router-link>
                    </li>

                </ul>
            </li>
        </template>
    </header-layout>
    <business-nav-bar :user="user"></business-nav-bar>
</template>
<script>
import { ref } from 'vue'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../stores/SettingStore.js'
import HeaderLayout from './layouts/HeaderLayout'
import BusinessNavBar from './BusinessNavBar.vue'
import { useUserStore } from '../../../stores/UserStore'
import { useMessageStore} from '../../../stores/MessageStore'
export default {
    components:{
        HeaderLayout,BusinessNavBar
    },
    props:{
        user:{
            type:[Array,Object]
        },
    },
    setup(props){
        const localizationStore = useLocalizationStore();
        const settingStore = useSettingStore();
        const siteUrl = ref(null);
        const userInfo = props.user
        return{
            localizationStore,settingStore,siteUrl,userInfo,
            userStore:useUserStore(),
            messageStore:useMessageStore()
        }
    },
    created(){
        this.siteUrl = baseUrl;
    },
    mounted(){
        Echo.channel('RoomMesssage.' + this.userInfo.userId)
        .listen('.new-message', (e) => {
            if(e.response){
                if(_.includes(['client-messages','messages'], this.$route.name)){
                    this.messageStore.newMessages = false;
                }else{
                    this.messageStore.newMessages = true
                }
            }else{
                this.messageStore.newMessages = false
            }

        });
        if(_.includes(['client-messages','messages'], this.$route.name)){

            this.messageStore.newMessages = false;
        }else{
            this.messageStore.checkNewMessage();
        }

    },
    methods:{

    }
}
</script>
